module.exports = __webpack_public_path__ + "img/14.ffda1ea9.jpg";